import { useMemo } from "react";
import { useSelector } from "react-redux";

export const usePermissionsHook = () => {
  const user = useSelector((state) => state.user);
  const isDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com",
    [user]
  );

  const isTempDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cnguyen@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com",
    [user]
  );

  const isAdmin = useMemo(() => {
    const permissions = user?.permissions || [];
    return permissions.includes("admin");
  }, [user]);

  const isUnderwriter = useMemo(() => {
    const permissions = user?.permissions || [];
    return permissions.includes("underwriting");
  }, [user]);

  return {
    isTempDevUser,
    isDevUser,
    isUnderwriter,
    isAdmin,
  };
};
